export enum TransactionReportType {
  Account = 'Account',
  MyTransactions = 'My Transactions',
  Expenses = 'Expenses',
  Budget = 'Budget',
  ExpenseReport = 'Expense Report',
  NeedsApproval = 'Needs Approval',
  AccountingTransactions = 'Accounting Transactions',
  Other = 'Other',
}